'use strict';

var _ = require('lodash');
var UserManagementDataService = function UserManagementDataService($q, restangular, UserFactory, userSecureService, configurationService, featureToggleService) {
  var staticDataMarketsApiByFeature = {
    'REVENUE_OPTIMIZER': restangular.one('staticdata').one('markets')
  };
  function getRestangularUserPreferences(containsOnlyPreferenceChanges) {
    if (containsOnlyPreferenceChanges) {
      return restangular.one('user').one('preferences');
    } else {
      return restangular.one('user');
    }
  }
  function updateUserLegsAndPrefs(userData, marketResp, marketPrefs, legResp, legPrefs, containsOnlyPreferenceChanges) {
    var updatedUserData = prepareUserPayload(userData, marketResp, marketPrefs, legResp, legPrefs);
    return getRestangularUserPreferences(containsOnlyPreferenceChanges).customPUT(updatedUserData);
  }
  function updateWorkflowSettings(userData, isOwnProfile) {
    var updatedUserData = prepareUserPayload(userData, userData.responsibilities.markets, userData.preferences.markets, userData.responsibilities.legs, userData.preferences.legs);
    return getRestangularUserPreferences(isOwnProfile).customPUT(updatedUserData);
  }
  function updateMultipleUsers(users) {
    var multiUserData = {
      'value': users
    };
    return restangular.one('user/bulk').customPUT(multiUserData);
  }
  function prepareUserPayload(userData, marketResp, marketPrefs, legResp, legPrefs) {
    var newUserData = {
      'userId': userData.userId,
      'roles': userData.roles,
      'organization': userData.organization,
      'isSabreEmployee': userData.isSabreEmployee,
      'isSystemOwner': userData.isSystemOwner,
      'isActive': userData.isActive,
      'firstName': userData.firstName,
      'lastName': userData.lastName,
      'email': userData.email,
      'cityCode': userData.cityCode,
      'responsibilities': {
        'markets': marketResp || [],
        'legs': legResp || []
      },
      'preferences': {
        'markets': marketPrefs || [],
        'legs': legPrefs || [],
        'workflowSettings': userData.preferences.workflowSettings || null,
        'dateTimeNumberFormatSettings': userData.preferences.dateTimeNumberFormatSettings || []
      }
    };
    return newUserData;
  }
  function updateSystemDefaultWorkflowSettings(workflowSettings) {
    var hepData = prepareSystemDefaultWorkflowSettings(workflowSettings);
    return restangular.one('configuration').customPUT(hepData, 'hep', {
      upsert: true
    });
  }
  function updateSystemDefaultDateTimeSettings(hepData) {
    return restangular.one('users').customPUT(hepData, 'dateTimeSettings');
  }
  function retrieveUserData() {
    return userSecureService.retrieveUserData();
  }
  function updateDateTimeSettings(dateTimeNumberFormatSettings) {
    var hepData = prepareSystemDefaultDateTimeSettings(dateTimeNumberFormatSettings);
    return updateSystemDefaultDateTimeSettings(hepData).then(retrieveUserData);
  }
  function deleteSystemDefaultWorkflowSettings() {
    return restangular.one('configuration/hep').customDELETE('bulk', {
      type: 'WorkflowSettings',
      filter: 'settingType==Default'
    });
  }
  function deleteSystemDefaultDateTimeSettings() {
    return restangular.one('configuration/hep').customDELETE('bulk', {
      type: 'DateTimeNumberFormatSettings',
      filter: 'settingType==Default'
    });
  }
  function getApiByFeature(apiMap) {
    var restApi;
    _.forOwn(apiMap, function (api, feature) {
      if (featureToggleService.isEnabled(feature)) {
        restApi = api;
        return;
      }
    });
    return restApi;
  }
  function updateMarkets(marketResp, userId) {
    var patchApi = getApiByFeature(staticDataMarketsApiByFeature);
    var marketData = prepareMarketDataForPatch(_.cloneDeep(configurationService.getMarkets()), marketResp, userId);
    if (!_.isEmpty(marketData.market)) {
      return patchApi.patch(marketData);
    }
    return true;
  }
  function removeUsersAsMarketOwners(users) {
    var userIds = _.map(users, function (user) {
      var factory = new UserFactory(user);
      return factory.getUserId();
    });
    var restApi = getApiByFeature(staticDataMarketsApiByFeature);
    var legRestApi = restangular.one('staticdata').one('legs');
    return $q.all({
      dataMarkets: restApi.get(),
      dataLegs: featureToggleService.isDisabled('REVENUE_OPTIMIZER') ? [] : legRestApi.get()
    }).then(function (results) {
      var marketsForPatch = [];
      var legsForPatch = [];
      _.transform(results.dataMarkets.market, function (results, market) {
        if (_.includes(userIds, market.owner)) {
          market.owner = '';
          results.push(market);
          return results;
        }
      }, marketsForPatch);
      _.transform(results.dataLegs.leg, function (results, leg) {
        if (_.includes(userIds, leg.owner)) {
          leg.owner = '';
          results.push(leg);
          return results;
        }
      }, legsForPatch);
      if (legsForPatch.length !== 0 && marketsForPatch.length === 0) {
        return $q.all([legRestApi.customPUT({
          leg: legsForPatch
        })]);
      } else if (legsForPatch.length === 0 && marketsForPatch.length !== 0) {
        return $q.all([restApi.patch({
          market: marketsForPatch
        })]);
      } else if (legsForPatch.length !== 0 && marketsForPatch.length !== 0) {
        return $q.all([restApi.patch({
          market: marketsForPatch
        }), legRestApi.customPUT({
          leg: legsForPatch
        })]);
      } else {
        return;
      }
    });
  }
  function updateUserForMarket(market, resp, userId) {
    var marketString = market.origin + '-' + market.destination;
    if (_.includes(resp, marketString)) {
      return _.merge(market, {
        'owner': userId
      });
    } else if (market.owner === userId) {
      return _.merge(market, {
        'owner': ''
      });
    }
  }
  function adjustPatchStructureToFeature(markets) {
    if (featureToggleService.isEnabled('REVENUE_OPTIMIZER')) {
      return {
        market: markets
      };
    }
  }
  function prepareMarketDataForPatch(markets, marketResp, userId) {
    var filteredMarkets = _.filter(markets, function (market) {
      return isValidMarket(market);
    });
    var marketsForPatch = _.map(filteredMarkets, function (market) {
      return updateUserForMarket(market, marketResp, userId);
    });
    marketsForPatch = removeNullAndAddIsNewFlag(marketsForPatch);
    return adjustPatchStructureToFeature(marketsForPatch);
  }
  function isValidMarket(market) {
    return !_.isNil(market.isNew) && !_.isNil(market.isLocal) && !_.isNil(market.isSignificant) && !_.isNil(market.controlType);
  }
  function updateLegMarkets(legResp, userId) {
    if (featureToggleService.isDisabled('REVENUE_OPTIMIZER')) {
      return true;
    }
    var restApi = restangular.one('staticdata').one('legs');
    return restApi.get().then(function (data) {
      var legMarketData = prepareLegMarketDataForPatch(data.leg, legResp, userId);
      if (!_.isEmpty(legMarketData.leg)) {
        return restApi.customPUT(legMarketData);
      }
      return true;
    });
  }
  function removeNullAndAddIsNewFlag(legsForPatch) {
    _.remove(legsForPatch, _.isEmpty);
    return _.map(legsForPatch, function (value) {
      if (!_.has(value, 'isNew')) {
        return _.merge(value, {
          'isNew': false
        });
      }
      return value;
    });
  }
  function prepareLegMarketDataForPatch(legs, legResp, userId) {
    var legsForPatch = _.map(legs, function (leg) {
      return updateUserForMarket(leg, legResp, userId);
    });
    legsForPatch = removeNullAndAddIsNewFlag(legsForPatch);
    return {
      leg: legsForPatch
    };
  }
  function prepareSystemDefaultWorkflowSettings(workflowSettings) {
    return {
      type: 'WorkflowSettings',
      hepKey: 'WorkflowSettings.Default',
      attributes: {
        settingType: 'Default'
      },
      properties: {
        workflowSettings: workflowSettings
      }
    };
  }
  function prepareSystemDefaultDateTimeSettings(dateTimeNumberFormatSettings) {
    return {
      type: 'DateTimeNumberFormatSettings',
      hepKey: 'DateTimeNumberFormatSettings.Default',
      attributes: {
        settingType: 'Default'
      },
      properties: {
        dateTimeNumberFormatSettings: dateTimeNumberFormatSettings
      }
    };
  }
  function getMarkets() {
    return _.sortBy(flattenMarkets(configurationService.getMarkets()), 'value');
  }
  function getLegs() {
    return restangular.one('staticdata').one('legs').get().then(function (data) {
      return _.sortBy(flattenLegs(data.leg), 'value');
    });
  }
  function flattenMarkets(markets) {
    return _.map(markets, function (market) {
      return {
        selected: false,
        value: market.origin + '-' + market.destination,
        isCodeShare: _.isNil(market.isSignificant) || _.isNil(market.isLocal) ? false : !market.isSignificant && !market.isLocal
      };
    });
  }
  function flattenLegs(legs) {
    return _.map(legs, function (leg) {
      return {
        selected: false,
        value: leg.origin + '-' + leg.destination
      };
    });
  }
  function flattenUsers(users) {
    return _.map(users, function (user) {
      if (user.responsibilities === undefined) {
        return {
          userId: user.userId,
          roles: user.roles,
          isActive: user.isActive,
          firstName: user.firstName,
          lastName: user.lastName,
          email: user.email,
          organization: user.organization,
          isSabreEmployee: user.isSabreEmployee,
          isSystemOwner: user.isSystemOwner,
          cityCode: user.cityCode,
          responsibilities: {
            legs: [],
            markets: []
          },
          preferences: {
            legs: user.preferences.legs,
            markets: user.preferences.markets,
            workflowSettings: user.preferences.workflowSettings,
            dateTimeNumberFormatSettings: user.preferences.dateTimeNumberFormatSettings
          }
        };
      } else {
        return {
          userId: user.userId,
          roles: user.roles,
          isActive: user.isActive,
          firstName: user.firstName,
          lastName: user.lastName,
          email: user.email,
          cityCode: user.cityCode,
          organization: user.organization,
          isSabreEmployee: user.isSabreEmployee,
          isSystemOwner: user.isSystemOwner,
          responsibilities: {
            legs: user.responsibilities.legs,
            markets: user.responsibilities.markets
          },
          preferences: {
            legs: user.preferences.legs,
            markets: user.preferences.markets,
            workflowSettings: user.preferences.workflowSettings,
            dateTimeNumberFormatSettings: user.preferences.dateTimeNumberFormatSettings
          }
        };
      }
    });
  }
  function getAllUsers() {
    return restangular.one('users').get().then(function (data) {
      return flattenUsers(data.users);
    });
  }
  function getTimeZoneCodes() {
    return restangular.one('ancillary').one('airport').one('timezone').one('codes').get();
  }
  function getDefaultWorkflowSettings() {
    return restangular.one('configuration').one('hep').get({
      type: 'WorkflowSettings'
    }).then(function (hepData) {
      return _.get(hepData, ['hepList', 0, 'properties', 'workflowSettings'], {});
    });
  }
  function getDefaultDateTimeSettings() {
    return restangular.one('configuration').one('hep').get({
      type: 'DateTimeNumberFormatSettings'
    }).then(function (hepData) {
      return _.get(hepData, ['hepList', 0, 'properties', 'dateTimeNumberFormatSettings'], {});
    });
  }
  function removeMarketResponsibilities(userId, markets) {
    return restangular.one('user').one('marketresponsibilities').one(userId).one(markets.join(',')).customDELETE();
  }
  function addMarketResponsibilities(userId, markets) {
    return restangular.one('user').one('marketresponsibilities').one(userId).one(markets.join(',')).customPUT();
  }
  function removeLegResponsibilities(userId, legs) {
    return restangular.one('user').one('legresponsibilities').one(userId).one(legs.join(',')).customDELETE();
  }
  function addLegResponsibilities(userId, legs) {
    return restangular.one('user').one('legresponsibilities').one(userId).one(legs.join(',')).customPUT();
  }
  return {
    getMarkets: getMarkets,
    getLegs: getLegs,
    updateUserLegsAndPrefs: updateUserLegsAndPrefs,
    getAllUsers: getAllUsers,
    getTimeZoneCodes: getTimeZoneCodes,
    prepareUserPayload: prepareUserPayload,
    updateMultipleUsers: updateMultipleUsers,
    updateWorkflowSettings: updateWorkflowSettings,
    getDefaultWorkflowSettings: getDefaultWorkflowSettings,
    updateSystemDefaultWorkflowSettings: updateSystemDefaultWorkflowSettings,
    deleteSystemDefaultWorkflowSettings: deleteSystemDefaultWorkflowSettings,
    getDefaultDateTimeSettings: getDefaultDateTimeSettings,
    updateDateTimeSettings: updateDateTimeSettings,
    deleteSystemDefaultDateTimeSettings: deleteSystemDefaultDateTimeSettings,
    updateMarkets: updateMarkets,
    updateLegMarkets: updateLegMarkets,
    removeUsersAsMarketOwners: removeUsersAsMarketOwners,
    removeMarketResponsibilities: removeMarketResponsibilities,
    addMarketResponsibilities: addMarketResponsibilities,
    removeLegResponsibilities: removeLegResponsibilities,
    addLegResponsibilities: addLegResponsibilities
  };
};
UserManagementDataService.$inject = ['$q', 'Restangular', 'UserFactory', 'UserSecureService', 'ConfigurationService', 'FeatureToggleService'];
module.exports = UserManagementDataService;